export const SYSTEM_NAME = 'SliceSize POS SE'
export const SYSTEM_VERSION = '2.0.1'
export const CONTROL_UNIT_SERIAL_XML_EXPORT = 'PTEST900000000001'
